import { validateImageUrl } from '../../../../shared/helpers/Image';
import { validateVideoUrl } from '../../../../shared/helpers/Video';
import { MessageTemplateDeafaultImageConstants } from '../../DetailConstants';
export function getDefaultImage(type) {
    switch (type) {
        case 'image':
            return MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_IMAGE_URL;
        case 'video':
            return MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_VIDEO_IMAGE_URL;
        case 'document':
            return MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_DEFAULT_DOCUMENT_IMAGE_URL;
        default:
            return '';
    }
}
export function getInvalidImage(type) {
    switch (type) {
        case 'image':
            return MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_IMAGE_INVALID_URL;
        case 'video':
            return MessageTemplateDeafaultImageConstants.MESSAGE_TEMPLATE_VIDEO_INVALID_URL;
        default:
            return '';
    }
}
export async function validateMedia(type, url) {
    if (!url)
        return false;
    if (type === 'image') {
        try {
            await validateImageUrl(url);
            return true;
        }
        catch (err) {
            return false;
        }
    }
    if (type === 'video') {
        try {
            const timeoutPromise = new Promise((_, reject) => {
                setTimeout(() => reject(new Error('timeout')), 2000);
            });
            const videoValidation = validateVideoUrl(url);
            await Promise.race([videoValidation, timeoutPromise]);
            return true;
        }
        catch (err) {
            return false;
        }
    }
    return false;
}
